export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const LOGIN_CHECK = 'LOGIN_CHECK';
export const UPDATE_EVENTS_COUNTER = 'UPDATE_EVENTS_COUNTER';
export const UPDATE_TIMEOFF_COUNTER = 'UPDATE_TIMEOFF_COUNTER';
